<template>
  <a-modal
    title="订单满足率历史记录查询"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <ls-api-table
      ref="dataTable"
      :columns="columns"
      :tableProps="tableProps"
      rowKey="id"
      :scroll="{ fixScreen: true, x: 1100 }"
    >
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text }">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </div>
      </template>
    </ls-api-table>
  </a-modal>
</template>

<script>
import { apiInvOrderSatisfyRateHisList } from '@/api/mes/scheduling-plan/order-satisfaction-rate'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  props: {},
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvOrderSatisfyRateHisList, true),
        pageCurrent: true
      },
      visible: false,
      queryParams: {
        headerId: ""
      },
      columns: [],
      columns1: [
        {
          title: '计划类型',
          dataIndex: 'planTypeName',
          align: 'center'
        },
        {
          title: '存放区域',
          dataIndex: 'areaName',
          align: 'center'
        },
        {
          title: '订单满足率',
          dataIndex: 'satisfyRate',
          align: 'center'
        },
        {
          title: '最后更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '最后更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        }
      ],
      columns2: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center'
        },
        {
          title: '安全库存水位',
          dataIndex: 'safetyStockLevel',
          align: 'center'
        },
        {
          title: '最后更新人',
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '最后更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        }
      ],
      tableList: []
    }
  },
  created () {},
  methods: {
    show (val, flag) {
      if (flag === "订单满足率") {
        this.columns = JSON.parse(JSON.stringify(this.columns1))
      }
      if (flag === "安全库存水位") {
        this.columns = JSON.parse(JSON.stringify(this.columns2))
      }
      this.queryParams.headerId = val.id
      this.visible = true
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 表单重置
    reset () {
      this.$refs.dataTable.myDataSource = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
